import { Color, CreateElement, Delay, Geometry, HorizontalAlign, Log, Rect, Scale, SetStyles, Size } from "../MyHelpers";
import {BetConfig, BetType, BigSymbolFreegamesCommonConfiguration, ISimpleBonusAction, JackpotValue2, LineWin, Money, SlotGameBet, SpinAndHoldCommonConfiguration } from "../api";
import { Track } from "../AudioManager";
import { IJackpotDisplay } from "../IJackpotDisplay";
import { IJackpotDisplayFactory } from "../IJackpotDisplayFactory";
import { JackpotDisplayFactory } from "../JackpotDisplayFactory";
import { JackpotDisplayProperties } from "../JackpotDisplayProperties";
import { JackpotDisplayParams } from "../JackpotDisplayParams";
import { MultigameParams } from "../MultigameParams";
import { FontResource } from "../ResourceManager/FontResource";
import { ImageResource } from "../ResourceManager/ImageResource";
import { ResourceIdentifier } from "../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, LoadingStage, ResourceManager } from "../ResourceManager/ResourceManager";
import { service } from "../services";
import { JackpotDisplay, InfoScreenSlider, Settings, FillingPotFeature, MenuType } from "../Settings";
import { SlotGameInitData } from "../SlotGameInitData";
import { ZIndex } from "../ZIndex";
import { BigSymbolFreegamesBonusFactory_1Screen } from "./Bonus/BigSymbolFreegames/BigSymbolFreegamesBonusFactory_1Screen";

import { BigSymbolFreegamesBonusParams } from "./Bonus/BigSymbolFreegames/BigSymbolFreegamesParams";
import { BigSymbolSpinAndHoldBonusFactory_1Screen } from "./Bonus/BigSymbolSpinAndHold/BigSymbolSpinAndHoldFactory_1Screen";
import { Bonus } from "./Bonus/Bonus";
import { SlotBonus } from "./Bonus/SlotBonus";
import { SpinAndHoldParams } from "./Bonus/SpinAndHold/SpinAndHoldParams";
import { SpinAndHoldBonusFactory_1Screen } from "./Bonus/SpinAndHold/SpinAndHold_1Screen";
import { FreegameBonusParams } from "./FreegameBonus/FreegameBonus";
import { FreegameBonusFactory_1Screen } from "./FreegameBonus/FreegameBonus_1Screen";
import { Panel } from "./panel/panel";
import { PanelFactory } from "./panel/PanelFactory";
import { PickBonusFactory } from "./PickBonus/PickBonus";
import { PickBonusParams } from "./PickBonus/PickBonusParams";
import { PickBonusFactory_2Screen } from "./PickBonus/PickBonus_2Screen";
import { IGenericSlider } from "./Slider/GenericSlider";
import { ISlideFactoryGeneric } from "./Slider/ISlideFactory";
import { SlotGameState } from "./SlotGameState";
import { SlotGameType1 } from "./SlotGameType1";
import { FactoryDoubleSlide1Screns, FactoryDoubleSlide2Screns } from "./Slider/Slide2/FactoryDoubleSlide";
import { SpriteResource } from "../ResourceManager/SpriteResource";
import { CanvasSprite } from "./Sprite/CanvasSprite";
import { IRandomInterval } from "../Context/RandomInterval";
import { MarkersInfoColors } from "./WinLineInfoMarkers";
import { GetOrientation, Orientation } from "../FitScreen";
import { IPaytable } from "./Paytable/IPayTable";
import { IPayTableFactory, IPaytableParams } from "./Paytable/IPayTableFactory";
import { PayTableFactory } from "./Paytable/PayTableFactory";
import { SlotGameMessages } from "./SlotGameScreenMessages";
import { PanelOnlineResponsive } from "./panel/panelOnlineResponsive";
import { SlotGameType1Shared } from "./SlotGameType1Shared";
import { ChangeSpeedFactor, availableSpinParams } from "../SpeedManager";
import { JSONResource } from "../ResourceManager/JSONResource";
import { SpinnableReelsBigCanvas } from "./SpinAnimation/SpinnableReelsBigCanvas";
import { SpinAnimation } from "./SpinAnimation/SpinAnimation";
import { ReelSetMapper } from "./SpinAnimation/ReelSetMapper";
import { SymbolCollection, SymbolTypeAnim } from "./SpineSymbols/SymbolsCollection";
import { SymbolPositionToAnimate } from "./SymbolsAnimation";
import { WinLinesAnimationParams } from "./WinLines/GenericWinLinesAnimation";
import { GameViewAppPixi } from "../engine/gameViewAppPixi";
import { SinglegameState } from "../../singlegame/Singlegame";
import { GameState } from "./GameState";
import { SlotGame } from "./SlotGame";
import { BonusLoadingItem } from "./Bonus/LoadingItem";
import { PopUpSettings, PopUpSettingsParams } from "./panel/PopUpSettings";
import { Button } from "../IO";


export class SlotGameType1_Responsive extends SlotGameType1 {

	//USE FOR 2 SCREEN
	protected pickBonusFactory_2Screen: PickBonusFactory = new PickBonusFactory_2Screen();

	//Spin And Hold Bonus for 2 Screen
	protected spinAndHoldBonusFactory_1Screen: SpinAndHoldBonusFactory_1Screen = new SpinAndHoldBonusFactory_1Screen();
	//BIG SYMBOL FREE GAME SPIN AND HOLD FACTORY
	protected bigSymbolSpinAndHoldBonusFactory_1Screen: BigSymbolSpinAndHoldBonusFactory_1Screen = new BigSymbolSpinAndHoldBonusFactory_1Screen();
	//BIG SYMBOL FREE GAME
	protected bigSymbolFreegameBonusFactory_1Screen: BigSymbolFreegamesBonusFactory_1Screen = new BigSymbolFreegamesBonusFactory_1Screen();
	protected freegameBonusFactory_1Screen: FreegameBonusFactory_1Screen = new FreegameBonusFactory_1Screen();
	//protected jackpotDisplay: JackpotDisplay1screen = null;
	protected _jackpotDisplay: IJackpotDisplay;

	protected get jackpotDisplay() : IJackpotDisplay {
		return this._jackpotDisplay
	}
	protected set jackpotDisplay(val: IJackpotDisplay) {
		this._jackpotDisplay = val
	}

	//variable to the factory
	protected JackpotDisplayFactory : IJackpotDisplayFactory= new JackpotDisplayFactory();
	protected viewSize: Size = null;
	protected jackpotTitleAnim: CanvasSprite = null; //Jubilee
	protected popUpResponsiveContainer: HTMLElement = null;
	protected popUpResponsiveContainerFit: HTMLElement = null;
	protected denomResponsiveContainer:HTMLElement = null;
	protected denomResponsiveContainerFit: HTMLElement = null;
	//protected titleJPAnim: IRandomInterval;



	protected override panelFactory: PanelFactory = new PanelFactory();
	protected override panel: Panel = null;

	//protected TitleContainer: HTMLElement = null;
	//public JackpotTitleImg : HTMLElement;

	protected override colorLineMarkers: MarkersInfoColors =
	{
		MarkerbackgroundColor: "linear-gradient(90deg, rgba(6,65,42,1) 0%, rgba(117,255,9,1) 35%, rgba(183,255,9,1) 55%, rgba(117,255,9,1) 75%, rgba(6,65,42,1) 100%), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
		//linearColor:"linear-gradient(to left , transparent, LightGoldenrodYellow,transparent ) 0 10 100%",
	};

	gameView: HTMLElement;

	responsiveContainer: HTMLElement;
	responsiveJackpot: HTMLElement;
	responsiveJackpotFit: HTMLElement;

	responsiveReels: HTMLElement;
	responsiveReelsFit: HTMLElement;

	responsivePanel: HTMLElement;
	responsivePanelFit: HTMLElement;

	legacyGameView: HTMLElement = CreateElement("div", {
		classes: ["legacy-game-view"]
	});

	// protected override get view(): HTMLElement
	// {
	// 	return this.legacyGameView;
	// }


	public constructor(multigameParams: MultigameParams, initData: SlotGameInitData, gameName: string) {
		super(multigameParams, initData, gameName);
		//this.panel = new PanelPyramid(this.systemContext, this.resid, "./", this.audio);

		//if (Settings.JackpotDisplay == JackpotDisplay.Enable) {
		this.screenProtocol = multigameParams.screenProtocol;

		if (initData.JackpotEnabled)
		{
			this.viewSize = new Size(Settings.ScreenWidth, Settings.ScreenHeight);
			//Interface with neccesary parameters for the jackpot
			let params: JackpotDisplayParams = {
				systemContext: this.systemContext,
				resid: this.resid,
				viewSize: this.viewSize,
				screenProtocol: this.screenProtocol
			};

			//ADD JACKPOT
			this.jackpotDisplay = this.JackpotDisplayFactory.CreateNewJackpotDisplay(params);

			this.ProtocolSetup();


		}
		//this.AddScreenHelp();

		// lets create 3 elements, top one for jackpot, center for reels, bottom for panel

		this.gameView = CreateElement("div", {
			classes: ["game-view"],
			style: {
				width: "100%",
				height: "100%",
			}
		});

		
		this.popUpResponsiveContainer = CreateElement('div',
			{
				classes: ['popup-responsive','container'],
				parentToAppend: this.gameView,
				style:{
					width: "100%",
					height: "100%",
					display: 'flex',
					position: "absolute",
					justifyContent: "center",
					alignItems: "center",
					zIndex:"1000",
					background: "rgb(0,0,0,0.8)",
				}
			}
		);

		this.popUpResponsiveContainerFit = CreateElement('div',
			{
				classes: ["popup", "container", 'fit'],
				parentToAppend: this.popUpResponsiveContainer,
				style:
				{
					boxSizing: "border-box",

					width: "100%",
					height: "100%",
					display: "flex",
					alignItems: "center",
					justifyContent: "center"
				}
			}
		);

		this.denomResponsiveContainer = CreateElement('div',
			{
				classes: ['denom-responsive', 'container'],
				parentToAppend: this.gameView,
				style:{
					width: "100%",
					height: "100%",
					display: 'flex',
					position: "absolute",
					justifyContent: "center",
					alignItems: "center",
					zIndex:"1000",
					background: "rgb(0,0,0,0.8)",
				}
			}
		);

		this.denomResponsiveContainerFit = CreateElement('div',
			{
				classes: ['denom', 'responsive-fit'],
				parentToAppend: this.denomResponsiveContainer,
				style:
				{
					boxSizing: "border-box",

					width: "100%",
					height: "100%",
					display: "flex",
					alignItems: "center",
					justifyContent: "center"
				}
			}
		);

		

		this.responsiveContainer = CreateElement("div", {
			classes: ["responsive-slotgametype1"],
			parentToAppend: this.gameView,
			style: {
				// border: "5px solid green",
				width: "100%",
				height: "100%",
				boxSizing: "border-box",
				display: "flex",
				flexDirection: "column",
			}
		});

		this.responsiveJackpot = CreateElement("div", {
			classes: ["responsive-jackpot-display"],
			parentToAppend: this.responsiveContainer,
			style: {
				// border: "5px solid red",
				boxSizing: "border-box",
				flexGrow: "1",

				display: "flex",
				alignItems: "center",
				justifyContent: "center",
			}
		});


		this.responsiveJackpotFit = CreateElement("div", {
			classes: ["responsive-jackpot-fit"],
			parentToAppend: this.responsiveJackpot,
			style: {
				// border: "5px solid red",
				boxSizing: "border-box",
				width: "100%",
				height: "100%",
				display: "flex",
				alignItems: "center",
				justifyContent: "center"
			}
		});

		this.responsiveReels = CreateElement("div", {
			classes: ["responsive-reels"],
			parentToAppend: this.responsiveContainer,
			style: {
				// border: "5px solid red",
				boxSizing: "border-box",
				flexGrow: "1",
			}
		});

		this.responsiveReelsFit = CreateElement("div", {
			classes: ["responsive-reels-fit"],
			parentToAppend: this.responsiveReels,
			style: {
				// border: "5px solid red",
				boxSizing: "border-box",

				width: "100%",
				height: "100%",
				display: "flex",
				alignItems: "center",
				justifyContent: "center"
			}
		});



		this.responsiveReelsFit.appendChild(this.view);
		SetStyles(this.view, {
			// //border: "5px solid green",
			position: "absolute",
			width: Settings.ScreenWidth + "px",
			height: Settings.ScreenHeight + "px",
		});

		this.responsivePanel = CreateElement("div", {
			classes: ["responsive-panel"],
			parentToAppend: this.responsiveContainer,
			style: {
				// border: "5px solid red",
				boxSizing: "border-box",
				//flexGrow: "1",
				height: "15%",
				display: "flex",
				alignItems: "flex-end",
				justifyContent: "center",
			}
		});

		this.responsivePanelFit = CreateElement("div", {
			classes: ["responsive-panel-fit"],
			parentToAppend: this.responsivePanel,
			style: {
				// border: "5px solid red",
				boxSizing: "border-box",

				width: "100%",
				height: Scale.Hpx(160),
				display: "flex",
				alignItems: "center",
				justifyContent: "center"
			}
		});


		// remove shit
		this.backgroundBaseGame.parentElement.removeChild(this.backgroundBaseGame);
		// this.CreateAppBonusView();

	}
	protected override CreateAppBonusView() {
		this.gameViewAppPixi = new GameViewAppPixi(this.resid, this.systemContext, this.gameName);
		this.gameViewAppPixi.OnDestroyCallback=()=>{
			if (Settings.fillingPotFeature == FillingPotFeature.Disable){
				this.spinnableReels.Destroy("Destroy SlotGameType1_Responsive");
			}
			if (Settings.fillingPotFeature == FillingPotFeature.Enable){
				this.fillingPotFeature?.Destroy();
			}
		}
		//call back for append into game engine pixi APP spinable reels or filling pot change whit  settings.js
		this.gameViewAppPixi.OnCreatedCallback = () => {
			if (Settings.fillingPotFeature == FillingPotFeature.Disable) {
				this.spinnableReels.Create(null, this.gameViewAppPixi.GetAppView());
			}
			if (Settings.fillingPotFeature == FillingPotFeature.Enable) {
				this.fillingPotFeature?.Create(this.gameViewAppPixi.GetAppView().stage);
			};
			this.basegameElement.appendChild(this.gameViewAppPixi.GetView());

			

			let popUpView = this.popUpMenuAnim.View();
			popUpView.style.bottom = "";
			popUpView.style.background = ""

			this.popUpResponsiveContainerFit.appendChild(popUpView);

			this.popUpResponsiveContainer.style.display = 'none';

			this.popUpMenuAnim.hidePopUpCallback = () =>
				{
					if (this.popUpResponsiveContainer.style.display != "none")
					{
						this.popUpResponsiveContainer.style.display = 'none';
					}
				}
		};
	}
	public override OnButtonChanged(button: Button, pressed: boolean)
	{

		if (this.stateMachine.IsState(SlotGameState.DoubleState))
		{
			this.doubleUpView.OnButtonChanged(button, pressed);
			this.panel?.ButtonChanged(button, pressed);	
			return;
		}

		if (pressed)
		{
			if (this.autoPlay || this.turboSpin)
			{
				this.AutoplayDisable();
				this.TurboSpinStop();
			}
			else if(!this.denomMenu.IsLocked() && !this.help.IsStarted() /*&& !this.payoutMenu.IsLocked()*/ )
			{
				let betsThisDenom: BetConfig[] = this.initData.EnabledBets.filter(b => b.Bet.Denom.InCents == this.selectedBet.Denom.InCents);

				// if (!this.AllowSpin)
				// {
				// 	return;
				// }
				if (button == Button.ButtonSpin)
				{
					this.SpinButton(pressed);
				}
				else if(button == Button.ButtonBet1)
				{
					if (betsThisDenom.length > 0)
					{
						let betIndex = this.initData.EnabledBets.indexOf(betsThisDenom[0]);
						if (!this.SelectBet2(betIndex))
                        {
                            this.SpinButton(true);
                            this.SpinButton(false);
                        }
					}
				}
				else if(button == Button.ButtonBet2)
				{
					if (betsThisDenom.length > 1)
					{
						let betIndex = this.initData.EnabledBets.indexOf(betsThisDenom[1]);
						if (!this.SelectBet2(betIndex))
                        {
                            this.SpinButton(true);
                            this.SpinButton(false);
                        }
					}
				}
				else if(button == Button.ButtonBet3)
				{
					if (betsThisDenom.length > 2)
					{
						let betIndex = this.initData.EnabledBets.indexOf(betsThisDenom[2]);
						if (!this.SelectBet2(betIndex))
                        {
                            this.SpinButton(true);
                            this.SpinButton(false);
                        }
					}
				}
				else if(button == Button.ButtonBet4)
				{
					if (betsThisDenom.length > 3)
					{
						let betIndex = this.initData.EnabledBets.indexOf(betsThisDenom[3]);
						if (!this.SelectBet2(betIndex))
                        {
                            this.SpinButton(true);
                            this.SpinButton(false);
                        }
					}
				}
				else if(button == Button.ButtonBet5)
				{
					if (betsThisDenom.length > 4)
					{
						let betIndex = this.initData.EnabledBets.indexOf(betsThisDenom[4]);
						if (!this.SelectBet2(betIndex))
                        {
                            this.SpinButton(true);
                            this.SpinButton(false);
                        }
					}
                }
                else if (button == Button.ButtonBetNext)
                {
                    this.NextBet();
                }
                else if (button == Button.ButtonBetUp)
                {
                    this.BetUp();
                }
                else if (button == Button.ButtonBetDown)
                {
                    this.BetDown();
                }
				else if (button == Button.ButtonMaxBet)
				{
					this.MaxBet();
				}
				else if (button == Button.ButtonAutoplay)
				{
					if (this.popUpMenuAnim.CheckPopUpVisibility())
					{
						this.popUpMenuAnim.HidePopUp();
						return
					}
					this.AutoplayToggle();
				}
				else if (button == Button.ButtonGamesMenu)
				{
					this.GamesMenu();
				}
				else if (button == Button.ButtonHelp)
				{
					this.Help();
				}
				else if(button == Button.ButtonPayout)
				{

				}
				else if (button == Button.ButtonVolumeNext)
				{
					this.audio.NextVolume();					
				}
				else if (button == Button.ButtonDenomMenu)
				{
					this.showDenomMenu = true;
					if (this.popUpMenuAnim.CheckPopUpVisibility())
						{
							this.popUpMenuAnim.HidePopUp();
							this.popUpResponsiveContainer.style.display = "none";
						}

					this.ShowAvailableDenoms();
				}
				else if (button == Button.ButtonSettings)
				{
					if (!this.popUpMenuAnim.CheckPopUpVisibility() && this.stateMachine.IsState(SlotGameState.Idle))
					{
						this.popUpResponsiveContainer.style.display = "flex";
						this.popUpMenuAnim.ShowPopUp();	
					}
					
				}
				else if (button == Button.ButtonCallAttendant)
				{
					
				}
				else if (button == Button.ButtonCreditsMoney) 
				{
					this.panel.ToggleCreditMoney();
				}
				else if (button == Button.ButtonDoubleUp) {
					if (this.doubleUpView)
					{
						if (this.stateMachine.IsState(SlotGameState.Idle) && this.lastSpinResult?.TotalWin.TotalWin.InCents > 0) {
							this.stateMachine.ChangeState(SlotGameState.DoubleState);
						}
					}
				}
				else {
					// Log.Debug(this.logGroup, "Unhandled button " + button);
				}
			}
			else if(this.help.IsStarted()){
				if(button == Button.ButtonSpin)
				{
					this.Hide(this.help.View());
					this.help.Stop();
				}
			}
			/*
			if(this.stateMachine.State() == SlotGameState.Bonus)
			{
				this.currentBonus.Spin();
			}
			*/
		}
		else
		{
			if (button == Button.ButtonSpin)
			{
				this.SpinButton(pressed);
			}
        }

		this.panel?.ButtonChanged(button, pressed);
	}
	
	protected override CreateGamePIXIElements(){
		this.shakeAnimation.CreateShakeAnimationPixi(this.fillingPotFeature?.GetReelContainer());

			for (let [name, feature] of this.features) {
				//await feature.ResourcesLoaded(resourceManager);

				if (feature) {
					feature.CreatePIXIAPP();
					this.gameViewAppPixi.GetAppView().stage.addChild(feature.ViewPIXIAPP());
				}
			};

			this.winLinesAnimation.CreatePIXIAPP();
			this.gameViewAppPixi?.GetAppView().stage.addChild(this.winLinesAnimation.ViewPIXIAPP());
			this.denomMenu.CreatePIXIAPP();
			this.gameViewAppPixi?.GetAppView().stage.addChild(this.denomMenu.ViewPIXIAPP());
			this.bigWinCountAnimation.CreatePIXIAPP();
			this.gameViewAppPixi?.GetAppView().stage.addChild(this.bigWinCountAnimation.ViewPIXIAPP());
			this.winMessageAnimation.CreatePIXIAPP();
			this.gameViewAppPixi?.GetAppView().stage.addChild(this.winMessageAnimation.ViewPIXIAPP());

			if(this.jackpotSharedShow != null){
				this.jackpotSharedShow?.Create();
				this.gameViewAppPixi?.GetAppView().stage.addChild(this.jackpotSharedShow?.View());			
			}

			this.bonusMultiplier?.Create(this.fillingPotFeature?.GetPositionBonusMultiplier());
			this.gameViewAppPixi.GetAppView().stage.addChild(this.bonusMultiplier?.View())
	}

	lastOrientation: Orientation = Orientation.Portrait;

	public async OnResize(w: number, h: number, orientation: Orientation) {

		await Delay(100);

			if (orientation == Orientation.Landscape)
			{
				if (this.initData.JackpotEnabled)
				{
					// switch jackpot to landscape
				}
				else
				{
					// remove paytable
					this.responsiveJackpot.style.display = "none";
				}
			}
			else
			{
				if (this.initData.JackpotEnabled)
				{
					// switch jackpot to landscape
				}
				else
				{
					// remove paytable
					this.responsiveJackpot.style.display = "flex";
				}
			}

		let reelsRatio = 0;
		let jackpotRatio = 0;



		if (this.paytable1s)
		{
			const r = this.responsiveJackpot.getBoundingClientRect();
			const parentRect = new Rect(0, 0, r.width, r.height);
			const childRect = new Rect(0, 0, Settings.ScreenWidth, Settings.ScreenHeight);

			// let fitRect = Geometry.FitRect(childRect, parentRect);
			// this.responsiveReelsFit.style.width = fitRect.width + "px";
			// this.responsiveReelsFit.style.height = fitRect.height + "px";

			let fitRatio = Geometry.FitRectRatio(childRect, parentRect);

			this.paytable1s.View().style.transform = `scale(${fitRatio})`;
			this.paytable1s.View().style.transformOrigin = `center`;
		}

		if (this.jackpotDisplay)
		{
			if (orientation != this.lastOrientation)
			{
				if (orientation == Orientation.Landscape)
				{
					this.responsiveJackpot.style.flexGrow = "0.5";
				}
				else
				{
					this.responsiveJackpot.style.flexGrow = "1";
				}
			}

			await Delay(100);

			this.jackpotDisplay.OnResize(w, h, orientation);

			let jackpotWidth = 0;
			let jackpotHeight = 0;
			if (orientation != Orientation.Portrait)
			{
				jackpotWidth = Scale.W(2400);
				jackpotHeight = Scale.H(1080 * 0.5);
			}
			else
			{
				jackpotWidth  = Scale.W(1920);
				jackpotHeight = Scale.H(1080);
			}



			const r = this.responsiveJackpot.getBoundingClientRect();
			console.log("responsiveJackpot: ", r.width, r.height);
			console.log("jackpotDisplay: ", jackpotWidth, jackpotHeight);

			const parentRect = new Rect(0, 0, r.width, r.height);
			const childRect = new Rect(0, 0, jackpotWidth, jackpotHeight);

			// let fitRect = Geometry.FitRect(childRect, parentRect);
			// this.responsiveReelsFit.style.width = fitRect.width + "px";
			// this.responsiveReelsFit.style.height = fitRect.height + "px";

			let fitRatio = Geometry.FitRectRatio(childRect, parentRect);

			this.jackpotDisplay.View().style.transform = `scale(${fitRatio})`;
			this.jackpotDisplay.View().style.transformOrigin = `center`;

			//this.jackpotDisplay.OnResize(w, h, orientation);
		}

		// reels
		{
			const r = this.responsiveReels.getBoundingClientRect();
			const parentRect = new Rect(0, 0, r.width, r.height);
			const childRect = new Rect(0, 0, Settings.ScreenWidth, Settings.ScreenHeight);

			// let fitRect = Geometry.FitRect(childRect, parentRect);
			// this.responsiveReelsFit.style.width = fitRect.width + "px";
			// this.responsiveReelsFit.style.height = fitRect.height + "px";

			let fitRatio = Geometry.FitRectRatio(childRect, parentRect);

			// if (orientation == Orientation.Landscape)
			// 	fitRatio *= 1.2;

			this.view.style.transform = `scale(${fitRatio})`;
			this.view.style.transformOrigin = `center`;

			this.popUpResponsiveContainerFit.style.transform = `scale(${fitRatio})`;
			this.popUpResponsiveContainerFit.style.transformOrigin = 'center';

			this.denomResponsiveContainerFit.style.transform = `scale(${fitRatio})`;
			this.denomResponsiveContainerFit.style.transformOrigin = 'center'
		}
		// panel
		{
			(this.panel as PanelOnlineResponsive).OnResize(w, h, orientation);
			const r = this.responsivePanel.getBoundingClientRect();
			const parentRect = new Rect(0, 0, r.width, r.height);

			// 1575 is design width of panel
			// 160 is design height of panel
			const childRect = new Rect(0, 0, Scale.W(1575), Scale.H(160));

			// let fitRect = Geometry.FitRect(childRect, parentRect);
			// this.responsiveReelsFit.style.width = fitRect.width + "px";
			// this.responsiveReelsFit.style.height = fitRect.height + "px";

			let fitRatio = Geometry.FitRectRatio(childRect, parentRect);

			this.responsivePanelFit.style.height = (Scale.H(160) * fitRatio) + "px";

			this.panel.View().style.transform = `scale(${fitRatio})`;
			this.panel.View().style.transformOrigin = `center`;
		}

		this.lastOrientation = orientation;

		console.log(`reels ratio: ${reelsRatio}, jackpot ratio: ${jackpotRatio}`);
	}

	protected ProtocolSetup(): void {

		service.api?.registerOperation("JackpotValuesUpdate", this.resid.ID(), (data) =>
			{
				const values = Object.values(data.JackpotValues);
				this.OnJackpotValues(values);
			});
	}

	public override async PrepareResources(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager) {
		// super.PrepareResources(loadingStage, resourceManager);
		if (Settings.fillingPotFeature == FillingPotFeature.Enable)
			{
				await this.fillingPotFeature?.PrepareResources(loadingStage, resourceManager);
			}

		if (loadingStage == LoadingStage.GamesConfig){
			//load Json Game
			resourceManager.Add(new JSONResource(`${this.basepath}resources/GameConfig.json`, this.resid.ScopedResourceName(`GameConfig-${this.gameName}-JSON`)));
		}
		else if (loadingStage == LoadingStage.GamesPreload)
		{
			await this.PrepareResourcesGamesPreload(resourceManager);
		}
		else if (loadingStage == LoadingStage.Games)
		{
			await this.jackpotDisplay?.PrepareResources(loadingStage,resourceManager);
			await this.PrepareResourcesGame(resourceManager);
		}

		await this.BonusesPrepare(loadingStage, resourceManager);

		// this.PrepareFonts(resourceManager);
		// if (Settings.JackpotSlider == InfoScreenSliderType.Enable) {
		// 	this.secondScreenHelp.PrepareResources(resourceManager);
		// }
		// else {
			// this.PrepareTitle(resourceManager);
			// this.TitleJackpotAnimPrepared(resourceManager);
		// }
		// this.PaytablePrepare(resourceManager);

	}
	protected override async PrepareResourcesGame(resourceManager: IWriteOnlyResourceManager): Promise<void> {

		await this.HelpPrepare(resourceManager);

		await this.PrepareFont(resourceManager);

		await this.BasegamePrepare(resourceManager);

		await this.BigWinPrepare(resourceManager);

		await this.FeaturesPrepare(resourceManager);

		await this.panel.PrepareResources(resourceManager);

		await this.help.PrepareResources(resourceManager);

		await this.PrepareWinLines(resourceManager);

		await this.AudioPrepare(resourceManager);

		await this.denomMenu.PrepareResources(resourceManager);

		await this.PresentationPrepare(resourceManager);

		await this.TurboSpinPrepare(resourceManager);

		await this.replayMessage.PrepareResources(resourceManager);
		this.responsiveContainer.appendChild(this.replayMessage.View());

		await this.doubleUpView?.PrepareResources(resourceManager);

		await this.jackpotSharedShow?.PrepareResources(resourceManager);

		await this.bonusMultiplier?.PrepareResources(resourceManager);

		await this.PrepareTitle(resourceManager);

		await this.TitleJackpotAnimPrepared(resourceManager);


		// await this.PaytablePrepare(resourceManager);

	}


	protected override async PrepareWinLines(resourceManager: IWriteOnlyResourceManager)
	{
		// construct win lines
		let winLinesAnimParams: WinLinesAnimationParams =
		{
			viewSize: this.multigameParams.viewSize,
			spinnableReels: this.spinnableReels,
			lines: this.playlines,
			logGroup: this.logGroup,
			resid: this.resid,
			systemContext: this.systemContext,
			slotWindow: this.windowRectangle,
			slotWindowSymbolSize: this.spinnableReels.GetWindowSymbolSize(),
			colorLineMarkers: this.colorLineMarkers,
			// settings: this.initData.Meta.onlineParams.settings,
			speedFactorAnimation: ChangeSpeedFactor[this.speedManager.GetDefaultCelebrationType()],
			gameName: this.initData?.Meta?.onlineParams?.original ?? this.initData.GameName,
			winLinesTypeStyle: this.gameConfig.winLinesTypeStyle,
		};

		// this.RegularWinLineTypeFactory = this.newWinLinesFactory.CreateWinLines(winLinesAnimParams);


		//if (FruitGames.includes(this.initData.GameName))
		//{
			//this.winLinesFactory = new WinLinesFactory();
		//}


		// TODO replace with factory
		//this.winLinesAnimation = new WinSquareAnimations(winLinesAnimParams);
		this.winLinesAnimation = this.winLinesFactory.CreateWinLinesPIXIAPP(winLinesAnimParams);


		//this.winLineMarkers = new WinLineMarkers(this.windowRectangle, this.spinnableReels.GetWindowSymbolSize(), this.playlines);

		this.winLinesAnimation.AddStartLineCallback((line: LineWin, color: Color) =>
		{
			this.audio.PlayLoop(this.resid.ScopedResourceName("linecount"));
			this.EnableCache = true;
			line = null;
			color = null;

		});

		let symbolPositions:SymbolPositionToAnimate[] = [];

		this.winLinesAnimation.AddNextLineCallback((line: LineWin, color: Color, animateOnlyWinningSymbols: boolean) =>
		{
			//this.winLineMarkers.Show(line.LineIndex, color);
			symbolPositions = [];
			this.panel.SetMessage(this.translator.t.linepay("" + (line.LineIndex +1), service.moneyFormatter.FormatCreditCurrentDenom(line.Win)));

			let lineindex:number = line.LineIndex;


			let symbolsToAnimate: number = this.playlines[lineindex].length;
			if (animateOnlyWinningSymbols)
			{
				symbolsToAnimate = line.SymbolCount;
			}


			for (let i = 0; i < symbolsToAnimate; i++) {
				symbolPositions.push(new SymbolPositionToAnimate(i, this.windowSymbolSize.Height - 1 - this.playlines[lineindex][i]));
			}

			this.screenProtocol?.Send(new SlotGameMessages.WiningSymbol(line.SymbolIndex), this.screenProtocolScope);

			//this.symbolsAnimation.Stop();
			//this.symbolsAnimation.Update();
			try {
				this.spinnableReels.StopSymbolsAnim();
				this.spinnableReels.PlaySymbolsAnim(symbolPositions);

				//this.spinnableReels.Stop(symbolPositions);

				this.EnableCache = false;
				// this.symbolsAnimation.Stop();
				// this.symbolsAnimation.Update();
				symbolPositions = null;
				lineindex = null;
				symbolsToAnimate = null;
				color = null;
				//this.symbolsAnimation.Start(symbolPositions);
				//this.EnableSymbolsAnimation(symbolPositions);
			} catch (error) {
				Log.Error(this.logGroup, "Error playanim symbol", error);
			}
			//this.audio.Stop(this.resid.ScopedResourceName("linecount"));
			//this.audio.PlayLoop(this.resid.ScopedResourceName("linecount"));
		});

		this.winLinesAnimation.AddCompleteCallbacks(() =>
		{
			//this.winLineMarkers.Hide();
			this.audio.Stop(this.resid.ScopedResourceName("linecount"));
			this.audio.Play(this.resid.ScopedResourceName("linecountend"));
			//this.stateMachine.ChangeState(SlotGameState.BonusTrigger);
			this.spinnableReels.StopSymbolsAnim()
			this.EnableCache = true;
			this.DisableSymbolsAnimation();
		});

		await this.winLinesAnimation.PrepareResources(resourceManager);
		// this.RegularWinLineTypeFactory.PrepareResources(resourceManager);
	}

	protected override async PrepareResourcesGamesPreload(resourceManager: IWriteOnlyResourceManager): Promise<void> {
		await this.PreparedPanel();
		await this.winMessageAnimation.PrepareResources(resourceManager);
		//move for GamePreload because takes more time save and share the spine symbol
		await this.SymbolsPrepare(resourceManager);

	}

	protected paytable1s: IPaytable = null;

	// protected async PaytablePrepare(resourceManager: IWriteOnlyResourceManager): Promise<void> {

	// 	// when jackpot enabled, load jackpot instead of paytable
	// 	if (this.initData.JackpotEnabled)
	// 	{
	// 		return;
	// 	}

	// 	const panelFactory: IPayTableFactory = new PayTableFactory();
	// 	let paytableParams : IPaytableParams ={
	// 		paytable: this.initData.Paytable,
	// 		symbolSpriteAnims: this.symbolSpriteAnims,
	// 		viewSize: this.viewSize,
	// 		symbols: this.symbols,
	// 		nameGame: this.gameName,
	// 		resid: this.resid,
	// 		systemContext: this.systemContext,
	// 		initData: this.initData,
	// 		translator: this.translator,
	// 		symbolsCollection: null
	// 	}


	// 	this.paytable1s = panelFactory.CreatePayTable(paytableParams);
	// 	this.paytable1s.View().style.position = "absolute";
	// 	this.responsiveJackpotFit.appendChild(this.paytable1s.View());
	// 	this.paytable1s.PrepareResources(resourceManager);
	// }

	public override PrepareFont(resourceManager: IWriteOnlyResourceManager): void 
	{
		
		resourceManager.Add(new FontResource(this.basepath +"resources/huggable.ttf",this.resid.ScopedResourceName(["BigSymbolFreeGames-font"])));
	
	}

	protected override OnWaitBonusStartConfigBegin(): void
	{
		//this.symbolsAnimation.Stop();
		//if (this.runingBonuses.length == 0 || this.bonusStartConfig)
		// if (this.runingBonuses.length == 0){
		// 	this.stateMachine.ChangeState(SlotGameState.Bonus);
		// }		
		if (this.runingBonuses.length != 0) {
			//i need change because this.bonusStartConfig are empty always the protocol its commented 
			if (this.stateMachine.IsState(SlotGameState.WaitBonusStartConfig)) {	
			// 	this.currentBonus = this.runingBonuses[this.runingBonuses.length-1];
			// 	this.currentBonus.CreateTransitionPixi();			
			// 	this.stateMachine.ChangeState(SlotGameState.Bonus);
			// }
			this.TurboSpinStop();
			this.AutoplayDisable();
			// TODO stop basegame
			// hide basegame
			// this.symbolsAnimation.Stop();
			// this.bonusTriggerAnimation.Stop();
			this.currentBonus = this.runingBonuses[this.runingBonuses.length-1];
			// this.currentBonus.GameSelected(this.gameViewAppPixi.GetAppView())			
			this.currentBonus.ShowVideoTransition();
			this.stateMachine.ChangeState(SlotGameState.Bonus);	
			// this.currentBonus.TriggerAnimationStopped();			
		}
		} else {
			this.stateMachine.ChangeState(SlotGameState.WaitCollect);
			
			//this.stateMachine.ChangeState(SlotGameState.Collect);
		}
	}

	//protected containerTitles : HTMLElement  = null;

	protected LoadTitle(resourceManager: IReadOnlyResourceManager) {


		// this.containerTitles = document.createElement("div");
		// this.containerTitles.style.position = "absolute";
		// this.containerTitles.style.position = "center";
		// this.containerTitles.style.alignContent = "center";
		// this.containerTitles.setAttribute("class", "containerTitles-" + this.name);
		// this.containerTitles.style.justifyContent = "center";
		// this.containerTitles.style.height = Scale.Hpx(180);
		// this.containerTitles.style.width = "75%"//Scale.Wpx(1120);
		// this.containerTitles.style.left = Scale.Xpx(0);
		// this.containerTitles.style.top = "0px";
		// this.containerTitles.style.display ="flex";
		// this.containerTitles.style.flexDirection = "row";

		// this.basegameElement.appendChild(this.containerTitles);



		// this.TitleContainer = document.createElement("div");
		// this.TitleContainer.style.display = "flex";
		// this.TitleContainer.style.position = "center";
		// this.TitleContainer.style.alignContent = "center";
		// this.TitleContainer.setAttribute("class", "titleGame-" + this.name);
		// this.TitleContainer.style.justifyContent = "center";
		// this.TitleContainer.style.height = Scale.Hpx(180);
		// this.TitleContainer.style.width = "100%";
		// // this.TitleContainer.style.left = Scale.Xpx(0);
		// // this.TitleContainer.style.top = "0px";
		// this.TitleContainer.style.background = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["title", this.name])).CssBackground(),
		// this.TitleContainer.style.backgroundSize = "contain";
		// this.TitleContainer.style.backgroundPosition = "center";
		// this.TitleContainer.style.backgroundRepeat = "no-repeat";
		// this.containerTitles.appendChild(this.TitleContainer);


		// if (Settings.JackpotDisplay != JackpotDisplay.Disable) {
		// 	this.JackpotTitleImg = document.createElement("div");
		// 	this.JackpotTitleImg.setAttribute("class", "jackpotTitleImg-" + Settings.JackpotDisplayType);
		// 	this.JackpotTitleImg.classList.add(this.resid.ScopedResourceName("JackpotTitleImg"));
		// 	this.TitleContainer.style.display = "flex";
		// 	this.JackpotTitleImg.style.position = "center";
		// 	this.JackpotTitleImg.style.alignContent = "center";
		// 	//this.JackpotTitleImg.style.top = Scale.Ypx(0);
		// 	//this.JackpotTitleImg.style.left = Scale.Xpx(500);
		// 	this.JackpotTitleImg.style.height = Scale.Hpx(180);
		// 	this.JackpotTitleImg.style.width = "100%";
		// 	//this.JackpotTitleImg.style.backgroundImage = resourceManager.Get<ImageResource>(ResourceIdentifier.Global.Add("titleJackpotDisplaySlider-" + Settings.JackpotDisplayType)).CssBackground();
		// 	this.JackpotTitleImg.style.backgroundPosition = "center";
		// 	this.JackpotTitleImg.style.backgroundRepeat = "no-repeat";
		// 	this.JackpotTitleImg.style.backgroundSize = "contain";
		// 	this.jackpotTitleAnim = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("titleJackpotDisplay")).sprite, canvasSize: new Size(Scale.W(450), Scale.H(180))});
		// 	this.JackpotTitleImg.appendChild(this.jackpotTitleAnim.View());
		// 	this.containerTitles.appendChild(this.JackpotTitleImg);
		// 	//this.jackpotTitleAnim.Start(true);
		// 	this.titleJPAnim = this.systemContext.TimingContext().CreateRandomInterval("titleJackpotDisplay", 1500, 6000, () => this.jackpotTitleAnim.Start(false));
		// }
	}

	protected secondScreenHelp: IGenericSlider = null;
	protected seconScreenHelpFactory:ISlideFactoryGeneric= new FactoryDoubleSlide1Screns();
	public AddScreenHelp()
	{
		// if (Settings.JackpotSlider == InfoScreenSliderType.Enable) {
		// 	this.secondScreenHelp = this.seconScreenHelpFactory.Create({
		// 		systemContext: this.systemContext,
		// 		initData: this.initData,
		// 		resid: this.resid,
		// 		translator: this.translator,
		// 		logGroup: this.logGroup,
		// 		symbolSpriteAnims: this.symbolSpriteAnims,
		// 		viewSize: this.viewSize,
		// 		backendSettings: this.multigameParams.backendSettings,
		// 		availableSymbols: null
		// 	});
		// }
		// else
		// {
		// 	//DONT LOAD SLIDER
		// }


	}



	//Title sprite animation Jacpot Jubilee
	protected TitleJackpotAnimPrepared(resourceManager: IWriteOnlyResourceManager){
		if (Settings.JackpotDisplay != JackpotDisplay.Disable)
		{

			resourceManager.AddGlobal(new SpriteResource(
				Settings.ResourcesFolder+"multigame/multigame/img/JackpotsResources-Slider/"+(JackpotDisplayProperties[Settings.JackpotDisplayType].alias ?? Settings.JackpotDisplayType)+"/titleJackpotDisplay",
				ResourceIdentifier.Global.Add("titleJackpotDisplay"),true, this.logGroup.Add("titleJackpotDisplay"),
				true
			));
		}
	}

	protected async PrepareTitle(resourceManager: IWriteOnlyResourceManager) {
		resourceManager.Add(new ImageResource(this.basepath + "resources/title.png", this.resid.ScopedResourceName(["title", this.name])));

		if (Settings.JackpotDisplay != JackpotDisplay.Disable)
		{
        	resourceManager.AddGlobal(new ImageResource(
				Settings.ResourcesFolder + "multigame/multigame/img/JackpotsResources-Slider/"+(JackpotDisplayProperties[Settings.JackpotDisplayType].alias ?? Settings.JackpotDisplayType)+"/titleJackpotDisplayImg.png",
				ResourceIdentifier.Global.Add("titleJackpotDisplaySlider-"+(JackpotDisplayProperties[Settings.JackpotDisplayType].alias ?? Settings.JackpotDisplayType)).Scope()
			));
		}
	}

	protected override ConstructReels(): void {
		this.spinnableReels = new SpinnableReelsBigCanvas(this.windowSymbolSize, this.windowRectangle, this.spinnableReelsParams , this.resid , this.systemContext);

		
		
		this.spinAnimation = new SpinAnimation(this.logGroup);
        this.spinAnimation.AddOnStartCallback(() => {
            this.audio.Play(this.resid.ScopedResourceName("leverpull"));
        });
		this.reelSetMapper = new ReelSetMapper(this.windowSymbolSize, this.logGroup)
	}

	public override async ResourcesLoaded(loadingStage: LoadingStage,resourceManager: IReadOnlyResourceManager) {

		if (Settings.fillingPotFeature == FillingPotFeature.Enable)
			{
				await this.fillingPotFeature?.ResourcesLoaded(loadingStage, resourceManager);
			}
		if (loadingStage == LoadingStage.GamesConfig)
		{
			this.gameConfig = resourceManager.Get<JSONResource>(this.resid.ScopedResourceName(`GameConfig-${this.gameName}-JSON`)).json;

			await this.ConstructReels()
			this.symbolCollection = new SymbolCollection(this.symbols,this.gameName,this.resid,this.basepath, this.spinnableReels ,this.gameConfig, this.logGroup,this.initData.PlayWindow);

		}
		else if (loadingStage == LoadingStage.GamesPreload)
		{
			await this.ResourcesLoadedGamesPreload(resourceManager)
		}
		else if (loadingStage == LoadingStage.Games)
		{
			await this.ResourcesLoadedGames(resourceManager)
			if (this.initData.JackpotEnabled)
				{

					if (this.jackpotDisplay)
					{
						await this.jackpotDisplay?.ResourcesLoaded(loadingStage, resourceManager);
						//ADD ZINDEX BECAUSE ITS HIDE WHEN YOU WIN SOME JACKPOT

						SetStyles(this.jackpotDisplay.View(), {
							zIndex: ZIndex.JackpotDisplay.toString(),
							top: "unset",
							left: "unset",
						});


						//this.view.appendChild(this.jackpotDisplay.View());
						this.responsiveJackpotFit.appendChild(this.jackpotDisplay.View());
						if (this.jackpotValuesBuffer != null) {
							this.OnJackpotValues(this.jackpotValuesBuffer);
						}
					}
				}
		}
		await this.BonusesLoaded(loadingStage, resourceManager);
		// super.ResourcesLoaded(loadingStage, resourceManager);

		// if(Settings.JackpotSlider == InfoScreenSlider.Disable){
		// 	//dont need slite use only title
		// 	this.LoadTitle(resourceManager);
		// }else if(this.secondScreenHelp !=null)	{
		// 	this.secondScreenHelp.ResourcesLoaded(resourceManager);
		// 	this.basegameElement.appendChild(this.secondScreenHelp.View());
		// }

		// let Reels: HTMLElement = this.view.querySelector(".spinnablereels-slotwindow");
		// Reels.style.top = Scale.Xpx(184);

		// this.PaytableLoaded(resourceManager);

		// let sharedView = SlotGameType1Shared.Instance().View();
		// if (sharedView)
		// {
		// 	//this.gamesContainer.appendChild(sharedView);
		// 	sharedView.style.top = "";
		// 	sharedView.style.bottom = Scale.ZERO_PX;

		// 	//view.appendChild(this.sharedView)
		// 	this.view.appendChild(sharedView);
		// }
		// this.panel.ResourcesLoaded(resourceManager);

		// this.responsivePanelFit.appendChild(this.panel.View());
		// this.gameView.appendChild((this.panel as PanelOnlineResponsive).ResponsiveView());
	}

	protected override async ResourcesLoadedGamesPreload(resourceManager: IReadOnlyResourceManager): Promise<void>
	{
		//move for GamePreload because takes more time save and share the spine symbol
		// construct symbols
		// await this.SymbolsLoaded(resourceManager);
	}

	protected override async ResourcesLoadedGames(resourceManager: IReadOnlyResourceManager): Promise<void>
	{
		await this.AudioLoaded(resourceManager);


		await this.LoadedHistory(resourceManager);

		// construct symbols
		await this.SymbolsLoaded(resourceManager);

		//this.symbolsAnimation = new SymbolsAnimation(this.symbolSpriteAnims, this.spinnableReels, this.reelSetMapper);
		//this.symbolsAnimation = new SpecificSymbolsAnimation(this.symbolSpriteAnims, this.spinnableReels, this.reelSetMapper, this);

		// construct basegame
		this.basegameElement = CreateElement("div", {
			classes: ["basegame"],
			parentToAppend: this.view,
			style: {
				width: "100%",
				height: "100%",

				backgroundSize: "cover",
				backgroundPosition: "center center",
				position: "relative",
			}
		});




		await this.spinnableReels.ResourcesLoaded(null , this.reelBackgroundTexture,this.reelBackgroundMaskTexture);
		//this.basegameElement.appendChild(this.spinnableReels.GetView());
		await this.LoadedReels();
		//this.RedrawAllReels();
		await this.InitZoomedInSymbols();

		if(this.initData.Meta.Demo == true)
		{

			this.basegameElement.appendChild(this.demoMessage);
		}
		//append denom and line message
		//this.basegameElement.appendChild(this.lineMessageLeftContainer);
		//this.basegameElement.appendChild(this.lineMessageRightContainer);
		//this.basegameElement.appendChild(this.denomMessage);


		await this.winLinesAnimation.ResourcesLoaded(resourceManager);



		// construct line markers
		//this.basegameElement.appendChild(this.winLineMarkers.LeftView());
		//this.basegameElement.appendChild(this.winLineMarkers.RightView());



		// basegame loaded
		await this.BasegameLoaded(resourceManager);

		//
		//await this.basegameElement.appendChild(this.winLinesAnimation.View());

		await this.LoadedFillingPot(resourceManager);

		// BIG WIN
		//this.winMessageAnimation = new WinMessageAnimation(this.multigameParams.viewSize);
		await this.BigWinLoaded(resourceManager);

		await this.FeaturesLoaded(resourceManager);

		await this.panel.ResourcesLoaded(resourceManager);



		// put panel on top
		// this.view.appendChild(this.panel.View());

		await this.HelpLoaded(resourceManager);

		await this.denomMenu.ResourcesLoaded(resourceManager);
		//this.view.appendChild(this.denomMenu.View());



		await this.PresentationLoaded(resourceManager);

		//this.bonusTriggerAnimation = new SpecificSymbolsAnimation(null, this.spinnableReels, this.reelSetMapper, this);


		this.panelWinLabel = this.translator.Translate(() => this.stateMachine.State() == SlotGameState.Idle ? this.translator.t.lastwin : this.translator.t.win);
		this.View()?.querySelector(".but-win-label")?.appendChild(this.panelWinLabel?.location);

		await this.TurboSpinLoaded(resourceManager);
		this.stateMachine.ChangeState(SlotGameState.Idle);

		this.stopAnimTriggerBonusAnim = this.systemContext.TimingContext().CreateTimeout("stopAnimTriggerBonusAnim", 2000, () => {
			this.stateMachine.ChangeState(SlotGameState.WaitBonusStartConfig);
			this.EnableCache = true;
			this.spinnableReels.StopSymbolsAnim();
			this.DisableSymbolsAnimation();
		});

		this.stopAnimTriggerScatterAnim = this.systemContext.TimingContext().CreateTimeout("stopAnimTriggerScatterAnim", 2000, () => {
			this.spinnableReels.StopSymbolsAnim();
			//this.symbolsAnimation.Stop();
			this.EnableCache = true;
			this.DisableSymbolsAnimation();
			this.OnScatterWinEnd();
		});

		this.nextTimeoutAnimTriggerScatterAnim = this.systemContext.TimingContext().CreateTimeout("nextTimeoutAnimTriggerScatterAnim", 2000, () => {
			this.PlayNextScatter()
			this.CheckifMoreScatter(this.scatterResult.PositionsPerSymbol[this.startkeysIndexScatter[this.currentIndex +1]]?.Position);
		});

		this.nextAnimTimeoutTriggerBonus = this.systemContext.TimingContext().CreateTimeout("nextAnimTimeoutTriggerBonus", 2000, () => {
			this.EnableCache = true;
			this.PlayNextTriggerBonus();
			this.CheckifMoreTriggerBonus();
		});


		await this.replayMessage.ResourcesLoaded(resourceManager);

		//Destroy all reels when all games it loaded
		//this.DestroyPixi();
		this.timeoutGameState = this.systemContext.TimingContext().CreateTimeout("timeoutGameState ReadyToPlay",1000,()=>{
			this.GameStateChanged(GameState.ReadyToPlay);
		});

		this.timeOutRequestFeature = this.systemContext.TimingContext().CreateTimeout("Request-Feature-Stops-Timeout",1500,()=>{
			if (this.turboSpin && this.currentFeature != null) {
				this.RequestFeatureStop();
			}
		});

		this.timeoutBigWinStart = this.systemContext.TimingContext().CreateTimeout("timeoutBigWinStart",2000,()=>{
			this.audio.Stop(this.resid.ScopedResourceName("bigwin"));
			this.shakeAnimation.Stop();
			this.stateMachine.ChangeState(SlotGameState.Win);
		});


		// this.timeoutRobotSpinStops = this.systemContext.TimingContext().CreateTimeout("timeoutRobotSpinStops",1000,()=>{
		// 	this.robotPlay.OnSpinStopAvailable();
		// });

		this.timeoutWaitBonusStartConfig = this.systemContext.TimingContext().CreateTimeout("timeoutWaitBonusStartConfig",1500,()=>{
			// this.currentBonus.Hide();
			// this.currentBonus.GameExit();
			// this.currentBonus.DestroyTransition();
			//this.currentBonus = this.runingBonuses[this.runingBonuses.length - 1];
			this.stateMachine.ChangeState(SlotGameState.WaitBonusStartConfig);
		});


		let timerBonusShow : number = 1000;
		this.timeoutBonusShow = this.systemContext.TimingContext().CreateTimeout("timeoutBonusShow",timerBonusShow,()=>{
			this.robotPlay.BonusStarted(this.currentBonus);
			this.symbolCollection.DestroyAllSymbols();
			this.currentBonus.GameSelected(this.gameViewAppPixi.GetAppView().stage);
			this.currentBonus.fillingPotFeature?.SetCurrentFromBaseGameLevels(this.fillingPotFeature?.GetCurrentLevels());
			this.currentBonus.fillingPotFeature?.SetBet(this.selectedBet);

			if (this.currentBonus.Name() != "FreeGameBonus") this.bonusMultiplier?.ResetLevel(this.selectedBet);
			//stops fillingPotFeature
			this.fillingPotFeature?.StopAnim();

			//for(let i = 0; i < this.runingBonuses.length; i++)
			//{
				//this.runingBonuses[i].Hide();
			//}
			//comment this and move for test it TransitionParticles
			this.currentBonus.Show();
			this.audio.Stop(this.resid.ScopedResourceName("background"));
			// this.basegameElement.style.display = "none";
			this.currentBonus.Start();
			//this.screenProtocol?.Send(new SlotGameMessages.BonusStart(this.currentBonus.Name()), this.screenProtocolScope);

			if (Settings.fillingPotFeature == FillingPotFeature.Disable) {
				this.spinnableReels.Destroy("SlotGameType1.timeoutBonusShow");
			} else {
				this.fillingPotFeature?.Destroy();
			}
		});

		this.timeoutBonusShowTransition = this.systemContext.TimingContext().CreateTimeout("timeoutBonusShow",500,()=>{
			this.currentBonus.ShowVideoTransition();
			this.currentBonus.BackGroundTransition();
			this.timeoutBonusShow.Start();
			//stops fillingPotFeature
			this.fillingPotFeature?.StopAnim();
		});

		if (this.doubleUpView)
		{
			this.responsiveContainer.appendChild(this.doubleUpView.View());
			await this.doubleUpView?.ResourcesLoaded(resourceManager);
		}

		this.lineCountBackground = this.audio.Track(this.resid.ScopedResourceName("lineCountBackground"));

		//let toAnimateFadeIn = { volume: 0  };
		// this.fadeinWinlinesSound = TweenMax.to(toAnimateFadeIn, {
		// 	volume: this.audio.GetAudioLevel() , duration: 0.85, onUpdate: () => track.SetVolumeAnalog(toAnimateFadeIn.volume),onStart : ()=> {
		// 		track.PlayLoop(Track.LoopForEver);
		// 	}
		// }).pause();

		await this.winMessageAnimation.ResourcesLoaded(resourceManager);
		// // messages
		for (let i = 0; i < this.wins.length; i++) {
			// 	let message = new WinMessage(this.wins[i].name, resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("winmsg").Add(this.wins[i].name)).sprite, this.wins[i].winMultiplier, this.audio.Track(this.resid.ScopedResourceName(this.wins[i].name)));
			// 	this.winMessageAnimation.AddMessage(message);
			await this.winMessageAnimation.AddSound(this.wins[i].name, this.audio.Track(this.resid.ScopedResourceName(this.wins[i].name)));
		}


		//await this.symbolsCollection.ResourcesLoaded(resourceManager);
		await this.jackpotSharedShow?.ResourcesLoaded(resourceManager);

		await this.bonusMultiplier?.ResourcesLoaded(resourceManager);


		if(Settings.JackpotSlider == InfoScreenSlider.Disable){
			//dont need slite use only title
			this.LoadTitle(resourceManager);
		}else if(this.secondScreenHelp !=null)	{
			await this.secondScreenHelp.ResourcesLoaded(resourceManager);
			this.basegameElement.appendChild(this.secondScreenHelp.View());
		}

		this.PaytableLoaded(resourceManager);

		let sharedView = SlotGameType1Shared.Instance().View();
		if (sharedView)
		{
			//this.gamesContainer.appendChild(sharedView);
			sharedView.style.top = "";
			sharedView.style.bottom = Scale.ZERO_PX;

			//view.appendChild(this.sharedView)
			this.responsiveContainer.appendChild(sharedView);
		}

		this.responsivePanelFit.appendChild(this.panel.View());
		this.gameView.appendChild((this.panel as PanelOnlineResponsive).ResponsiveView());
		// this.responsiveContainer.appendChild(this.gameViewAppPixi.GetView());

		this.stateMachine.ChangeState(SlotGameState.Idle);


	}
	protected PaytableLoaded(resourceManager: IReadOnlyResourceManager): void
	{
		this.paytable1s?.ResourcesLoaded(resourceManager)
		this.paytable1s?.Update(true);
	}

	protected override PreparedPanel(): void {
		// super.PreparedPanel();
		this.panel = this.panelFactory.CreateNewPanel({
			systemContext: this.systemContext,
			resid: this.resid,
			resourcesBasePath: "./",
			audio: this.audio,
			backendSettings: this.multigameParams.backendSettings,
			translator: this.translator,
			panelColor:this.panelColor,
			doubleupEnabled: !!this.doubleUpView,
			symbolAnimationType: this.gameConfig?.symbolsType ?? SymbolTypeAnim.Sprites
		});
		this.speedManager.Load(this.multigameParams.backendSettings);

		let PopUpParams: PopUpSettingsParams =
		{
			audio: this.audio,
			// backendSettings: this.multigameParams.backendSettings,
			panelColors: this.panelColor,
			translator: this.translator,
			systemContext: this.systemContext,
			speedManager: this.speedManager,
		}
		let defaultVolume = this.multigameParams.backendSettings.GetNum("system.defaultVolume", 3);

		this.popUpMenuAnim = new PopUpSettings(PopUpParams);
		this.popUpMenuAnim.DefaultVolumeLevel(defaultVolume);

		this.speedManager.CreateUpdateList(this.popUpMenuAnim)

		this.popUpMenuAnim.OnSpeedChanged = (changeSpeedParams) =>
			{
				this.SpeedChanged(changeSpeedParams);
				console.log("Changed Params:", changeSpeedParams)

			};

		service.translator?.SetOnLanguageChangedCallback((t) => {

            this.panel.SetMessage(this.clientState.Balance() <= 0 ? this.translator.t.message_insertcredit : this.translator.t.message_pressspin);

			if (this.turboSpin)
			{
				this.panel.SpinButtonLabelChange(t.turbo);
			}
			else
			{
				this.panel.SpinButtonLabelChange(t.spin);
			}
		});
	}

	protected jackpotValuesBuffer: JackpotValue2[] = null;

	public OnJackpotValues(data: JackpotValue2[]) {
		this.jackpotDisplay?.UpdateValues(data);
	}

	public override Update(): void {
		// super.Update()
		this.spinAnimation?.Update();

		this.jackpotDisplay?.Update();

		if (this.stateMachine.State() != SlotGameState.Bonus)
			{
				this.spinnableReels?.Update();
			}

		if (this.stateMachine.State() == SlotGameState.Bonus)
			{
				if (this.currentBonus)
				{
					this.currentBonus.Update();
				}
			}
			if (this.forceSymbolsUpdate && this.stateMachine.State() != SlotGameState.Bonus) {

				// check symbol canvases
				for (let reelIndex = 0; reelIndex < this.spinnableReels?.GetWindowSymbolSize().Width; reelIndex++) {
					this.RedrawReel(reelIndex);
				}

				this.forceSymbolsUpdate = false;
			}



			if (this.help?.IsStarted())
			{
				this.help.Update()
			}

			this.doubleUpView?.Update();

			if (this.stateMachine.State() != SlotGameState.Bonus)
			{
				//this.symbolsAnimation.Update();
				this.winMessageAnimation?.Update();
				this.shakeAnimation?.Update();
				this.winLinesAnimation?.Update();

				this.fillingPotFeature?.Update();
			}

			this.gameViewAppPixi?.Update();

		if(this.secondScreenHelp !=null){
			this.secondScreenHelp.Update();
		}
		this.jackpotTitleAnim?.Update();
		this.paytable1s?.Update(false);
	}
	protected override RedrawReel(reelIndex: number): void
	{
		// 2 symbols more than window height
		//	 - scrolling reveals additional symbol on top
		//	 - we don't want to change top symbol right at the top window line,
		//     in case the top symbols peeks out a little


		this.currentSymbols[reelIndex] = this.reelSetMapper.GetReelMapper(reelIndex).GetSymbols2();

		for (let rowIndex: number = 0; rowIndex < this.currentSymbols[reelIndex].length; rowIndex++) {
			this.DrawSymbol(reelIndex, rowIndex);
		}
	}

	protected override AudioPrepare(resourceManager: IWriteOnlyResourceManager): void {
		super.AudioPrepare(resourceManager);
		this.audio.AddTrack(new Track(this.commonpath + "resources/Dragontracks/pickbonusDragonLink" + Settings.audioFormat, this.resid.ScopedResourceName("pickbonus")));

	}

	// protected override SetWindowsView(): void {
	// 	let w = 1774;
	// 	let h = 885;

	// 	let x = (1920 - w) / 2
	// 	let y = (1080 - h) / 2

	// 	this.windowRectangle = new Rect(Scale.X(x), Scale.Y(y), Scale.W(w), Scale.H(h));

	// 	this.windowSymbolSize = new Size(
	// 		this.initData.PlayWindow.Width,
	// 		this.initData.PlayWindow.Height
	// 	);
	// }

	protected override async PickBonusPrepare(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager) {
		let pickBonusparams: PickBonusParams =
		{
			systemContext: this.systemContext,
			resid: this.resid,
			logGroup: this.logGroup,
			screenProtocol: this.screenProtocol,
			screenProtocolScope: this.screenProtocolScope,
			gameBonusResourcesBasePath: this.basepath + "resources/PickBonus/",
			commonBonusResourcesBasePath: this.commonpath + "resources/PickBonus/",
			bonusConfiguration: this.initData.BonusConfiguration.PickBonus,
			pickElementFactory: this.pickBonusFactory,
			screenSize: this.multigameParams.viewSize,
			panel: this.panel,
			audio: this.audio,
			translator: this.translator,
			robotPlay: this.robotPlay,
			slotGameMeta: this.initData.Meta,
			clientState: this.clientState,
			jackpotRequired: this.multigameParams.jackpotRequired,
			bonusAutoplay: this.multigameParams.backendSettings.GetBool("play.bonusautoplay", true)
		};

		//USE FOR 2 SCREEN

		let pickBonus: SlotBonus = this.pickBonusFactory_2Screen.CreatePickBonus(this.name, pickBonusparams);

		//change state whCreateImgTransition
		//after bonus com.GetAppView()pickBonus.SetBonusFinishedCallback(() => this.stateMachine.ChangeState(SlotGameState.BigWinTotal));
		pickBonus.SetBonusPanelRequiredCallback((required: boolean) => {
			if (required)
				this.panel.Show();
			else
				this.panel.Hide();
		});

		await pickBonus.PrepareResources(loadingStage, resourceManager);

		this.bonusList.set(Bonus.PickBonus, pickBonus);


	}

	protected override async FreegamesPrepare(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager): Promise<void> {
		// super.FreegamesPrepare(loadingStage, resourceManager);
		if (loadingStage == LoadingStage.GamesPreload)
			{
				let fgparams: FreegameBonusParams =
				{
					systemContext: this.systemContext,
					resid: this.resid,
					logGroup: this.logGroup,
					screenProtocol: this.screenProtocol,
					screenProtocolScope: this.screenProtocolScope,
					gameResourcesBasePath: this.basepath,
					gameBonusResourcesBasePath: this.basepath + "resources/FreeGameBonus/",
					commonBonusResourcesBasePath: this.commonpath + "resources/FreeGameBonus/",
					screenSize: this.multigameParams.viewSize,
					windowSymbolSize: this.windowSymbolSize,
					windowRectangle: this.windowRectangle,
					symbolSpriteAnims: null,
					symbolSpriteAnimsByName: null,
					playlines: this.playlines,
					// reelSet: <number[][]>this.initData.BonusConfiguration.FreeGameBonus.ReelSet,
					startPositions: this.initData.BonusConfiguration.FreeGameBonus.ReelSet.map(r => 0),
					panel: this.panel,
					audio: this.audio,
					// TODO remove
					lines: this.selectedBet.Lines,

					// TODO remove?
					denom: this.selectedBet.Denom.InCents,

					// TODO remove?
					linesPlayed: this.selectedBet.Lines,

					bonusConfiguration: this.initData.BonusConfiguration.FreeGameBonus,
					pickElementFactory: this.freegameBonusFactory,
					clientState: this.clientState,
					translator: this.translator,
					robotPlay: this.robotPlay,
					slotGameMeta: this.initData.Meta,
					slotGameInitData: this.initData,
					slotGame: this,
					availableSymbols: this.symbols,
					availableSymbolsMap: this.symbolsMap,
					jackpotRequired : this.multigameParams.jackpotRequired,
					color: this.color,
					bonusList : this.bonusList,
					pixiSpritesByName: null,
					spinnableReelsParams : this.spinnableReelsParams,
					reelBackgroundTexture:this.reelBackgroundTexture,
					reelBackgroundMaskTexture:this.reelBackgroundMaskTexture,
					colorLineMarkers : this.colorLineMarkers,
					initData : this.initData,
					skinAttachmentFillingPotFeature : this.skinAttachmentFillingPotFeature,
					reelAnimationParams: availableSpinParams[this.speedManager.GetDefaultReelSpeedType()],
					winAnimationSpeedFactor: ChangeSpeedFactor[this.speedManager.GetDefaultCelebrationType()],
					symbolCollection : this.symbolCollection,
					gameConfig : this.gameConfig,
					backendSettings: this.multigameParams.backendSettings
				};

				console.log("CreateParamsFG:",fgparams);
				let freegameBonus: SlotBonus = this.freegameBonusFactory.CreateFreegameBonusPIXIAPP(this.gameName, fgparams);

				// after bonus comes collect
				freegameBonus.SetBonusFinishedCallback(() => {
					//this.stateMachine.ChangeState(SlotGameState.BigWinTotal);
					this.OnBonusFinished();
				});

				freegameBonus.SetBonusRunFinishedCallback((run: ISimpleBonusAction[]) => {
					this.OnBonusRunFinish(run);
				})
				freegameBonus.SetBonusPanelRequiredCallback((required: boolean) => {
					if (required)
						this.panel.Show();
					else
						this.panel.Hide();
				});

				this.bonusList.set(Bonus.FreeGameBonus,freegameBonus);
			}

			resourceManager.SetCurrentGame(this.initData.Meta.onlineParams.original)
			let freegameBonus = this.bonusList.get(Bonus.FreeGameBonus);
			await freegameBonus.PrepareResources(loadingStage, resourceManager);
			resourceManager.SetCurrentGame(null)

		// if (loadingStage != LoadingStage.GamesPreload)
		// {
		// 	return
		// }

		// let fgparams: FreegameBonusParams =
		// {
		// 	systemContext: this.systemContext,
		// 	resid: this.resid,
		// 	logGroup: this.logGroup,
		// 	screenProtocol: this.screenProtocol,
		// 	screenProtocolScope: this.screenProtocolScope,
		// 	gameResourcesBasePath: this.basepath,
		// 	gameBonusResourcesBasePath: this.basepath + "resources/FreeGameBonus/",
		// 	commonBonusResourcesBasePath: this.commonpath + "resources/FreeGameBonus/",
		// 	screenSize: this.multigameParams.viewSize,
		// 	windowSymbolSize: this.windowSymbolSize,
		// 	windowRectangle: this.windowRectangle,
		// 	symbolSpriteAnims: this.symbolSpriteAnims,
		// 	symbolSpriteAnimsByName: this.symbolSpriteAnimsByName,
		// 	playlines: this.playlines,
		// 	reelSet: <number[][]>this.initData.BonusConfiguration.FreeGameBonus.ReelSet,
		// 	startPositions: this.initData.BonusConfiguration.FreeGameBonus.ReelSet.map(r => 0),
		// 	panel: this.panel,
		// 	audio: this.audio,
		// 	color: this.color,
		// 	lines: this.selectedBet.Lines,
		// 	denom: this.selectedBet.Denom.InCents,
		// 	bonusConfiguration: this.initData.BonusConfiguration.FreeGameBonus,
		// 	pickElementFactory: this.freegameBonusFactory,
		// 	// TODO duplicate with lines
		// 	linesPlayed: this.selectedBet.Lines,

		// 	clientState: this.clientState,
		// 	translator: this.translator,
		// 	robotPlay: this.robotPlay,
		// 	slotGameMeta: this.initData.Meta,
		// 	slotGameInitData: this.initData,
		// 	slotGame: this,
		// 	availableSymbols: this.symbols,
		// 	availableSymbolsMap: this.symbolsMap,
		// 	jackpotRequired: this.multigameParams.jackpotRequired,
		// 	bonusList: this.bonusList,
		// 	pixiSpritesByName: this.pixiSpritesByName,
		// 	spinnableReelsParams: this.spinnableReelsParams,
		// 	reelBackgroundTexture:this.reelBackgroundTexture,
		// 	reelBackgroundMaskTexture:this.reelBackgroundMaskTexture,
		// 	colorLineMarkers : this.colorLineMarkers,
		// 	initData : this.initData,
		// 	skinAttachmentFillingPotFeature : this.skinAttachmentFillingPotFeature,
		// 	reelAnimationParams: availableSpinParams[this.speedManager.GetDefaultReelSpeedType()],
		// 	winAnimationSpeedFactor: ChangeSpeedFactor[this.speedManager.GetDefaultCelebrationType()],
		// 	symbolCollection : this.symbolCollection,
		// 	gameConfig : this.gameConfig,
		// 	backendSettings: this.multigameParams.backendSettings
		// };

		// let freegameBonus: SlotBonus = this.freegameBonusFactory_1Screen.CreateFreegameBonus(this.gameName, fgparams);
		// freegameBonus.SetBonusFinishedCallback(() => {
		// 	this.OnBonusFinished();
		// });

		// freegameBonus.SetBonusRunFinishedCallback((run: ISimpleBonusAction[]) => {
		// 	this.OnBonusRunFinish(run);
		// });


		// // after bonus comes collect
		// freegameBonus.SetBonusFinishedCallback(() => this.stateMachine.ChangeState(SlotGameState.BigWinTotal));
		// freegameBonus.SetBonusPanelRequiredCallback((required: boolean) => {
		// 	if (required)
		// 		this.panel.Show();
		// 	else
		// 		this.panel.Hide();
		// });

		// await freegameBonus.PrepareResources(loadingStage, resourceManager);

		// this.bonusList.set(Bonus.FreeGameBonus, freegameBonus);
	}

	protected override async FreegamesLoaded(loadingStage: LoadingStage, resourceManager: IReadOnlyResourceManager): Promise<void>
	{

		let freegameBonus = this.bonusList.get(Bonus.FreeGameBonus);

		if (loadingStage == LoadingStage.Games)
		{
			let freegameView = freegameBonus.View();
			SetStyles(freegameView, {
				width: this.multigameParams.viewSize.Width.px(),
				height: this.multigameParams.viewSize.Height.px()
			});

			this.basegameElement.appendChild(freegameView);

			// hide all bonuses by default
			freegameBonus.Hide();
		}

		if (this.bonusList.has(Bonus.FreeGameBonus))
		{
			await freegameBonus?.ResourcesLoaded(loadingStage, resourceManager);
		}
	}

	protected override async SpinAndHoldPrepare(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager): Promise<void> {
        // super.SpinAndHoldPrepare(loadingStage, resourceManager);

		if (loadingStage != LoadingStage.GamesPreload)
			{
				return;
			}

			let bonusParams: SpinAndHoldParams =
			{
				systemContext: this.systemContext,
				resid: this.resid,
				logGroup: this.logGroup,
				screenProtocol: this.screenProtocol,
				screenProtocolScope: this.screenProtocolScope,
				gamepath: this.basepath,
				commonpath: this.commonpath,
				gameBonusResourcesBasePath: this.basepath + "resources/HoldAndSpin/",
				commonBonusResourcesBasePath: this.commonpath + "resources/HoldAndSpin/",
				screenSize: this.multigameParams.viewSize,
				// windowSymbolSize: this.windowSymbolSize,
				// windowRectangle: this.windowRectangle,
				symbolSpriteAnims: null,
				symbolSpriteAnimsByName: null,
				playlines: this.playlines,
				symbols: this.symbols,
				spinnableReelsParams: this.spinnableReelsParams,
				//reelSet: <number[][]>this.initData.bonusConfiguration["SpinAndHoldBonus"].ReelSet,
				//startPositions: [0, 0, 0, 0, 0],
				panel: this.panel,
				audio: this.audio,
				// TODO remove
				lines: this.selectedBet.Lines,

				// TODO remove?
				denom: this.selectedBet.Denom.InCents,

				// TODO remove?
				linesPlayed: this.selectedBet.Lines,
				clientState: this.clientState,
				translator: this.translator,
				robotPlay: this.robotPlay,
				slotGameMeta: this.initData.Meta,
				slotGameInitData: this.initData,
				slotGame: this as unknown as SlotGame,
				color: this.color,
				jackpotEnable : this.multigameParams.jackpotRequired,
				bonusAutoplay: this.multigameParams.backendSettings.GetBool("play.bonusautoplay", true),
				pixiSpritesByName: null,
				reelAnimationParams: availableSpinParams[this.speedManager.GetDefaultReelSpeedType()],
				FpsFactor: ChangeSpeedFactor[this.speedManager.GetDefaultCelebrationType()],
				gameConfig : this.gameConfig,
				symbolCollection : this.symbolCollection,
			};

			let bonusConfig: SpinAndHoldCommonConfiguration = this.initData.BonusConfiguration.SpinAndHold;

			let spinAndHoldBonus: SlotBonus = this.spinAndHoldBonusFactory.CreateSpinAndHoldBonusPIXIApp(this.gameName, bonusParams, bonusConfig);

			// after bonus comes collect
			//spinAndHoldBonus.SetBonusFinishedCallback(() => this.stateMachine.ChangeState(SlotGameState.BigWinTotal));
			spinAndHoldBonus.SetBonusFinishedCallback(() => {
				this.OnBonusFinished();
			});

			spinAndHoldBonus.SetBonusRunFinishedCallback((run: ISimpleBonusAction[]) => {
				this.OnBonusRunFinish(run);
			});

			spinAndHoldBonus.SetBonusPanelRequiredCallback((required: boolean) => {
				if (required)
					this.panel.Show();
				else
					this.panel.Hide();
			});

			resourceManager.SetCurrentGame(this.initData.Meta.onlineParams.original)
			await spinAndHoldBonus.PrepareResources(loadingStage, resourceManager);
			resourceManager.SetCurrentGame(null)


			this.bonusList.set(Bonus.SpinAndHold, spinAndHoldBonus);

		// if (loadingStage != LoadingStage.GamesPreload)
		// 	{
		// 		return;
		// 	}

		// let bonusParams: SpinAndHoldParams =
		// {
		// 	systemContext: this.systemContext,
		// 	resid: this.resid,
		// 	logGroup: this.logGroup,
		// 	screenProtocol: this.screenProtocol,
		// 	screenProtocolScope: this.screenProtocolScope,
		// 	gamepath: this.basepath,
		// 	commonpath: this.commonpath,
		// 	gameBonusResourcesBasePath: this.basepath + "resources/HoldAndSpin/",
		// 	commonBonusResourcesBasePath: this.commonpath + "resources/HoldAndSpin/",
		// 	screenSize: this.multigameParams.viewSize,
		// 	windowSymbolSize: this.windowSymbolSize,
		// 	windowRectangle: this.windowRectangle,
		// 	symbolSpriteAnims: this.symbolSpriteAnims,
		// 	symbolSpriteAnimsByName: this.symbolSpriteAnimsByName,
		// 	playlines: this.playlines,
		// 	symbols: this.symbols,
		// 	spinnableReelsParams: this.spinnableReelsParams,
		// 	//reelSet: <number[][]>this.initData.bonusConfiguration["SpinAndHoldBonus"].ReelSet,
		// 	//startPositions: [0, 0, 0, 0, 0],
		// 	panel: this.panel,
		// 	audio: this.audio,
		// 	// TODO remove
		// 	lines: this.selectedBet.Lines,

		// 	// TODO remove?
		// 	denom: this.selectedBet.Denom.InCents,

		// 	// TODO remove?
		// 	linesPlayed: this.selectedBet.Lines,
		// 	clientState: this.clientState,
		// 	translator: this.translator,
		// 	robotPlay: this.robotPlay,
		// 	slotGameMeta: this.initData.Meta,
		// 	slotGameInitData: this.initData,
		// 	slotGame: this,
		// 	color: this.color,
		// 	jackpotEnable : this.multigameParams.jackpotRequired,
		// 	bonusAutoplay: this.multigameParams.backendSettings.GetBool("play.bonusautoplay", true),
		// 	pixiSpritesByName : this.pixiSpritesByName,
        //     jackpotDisplay: this.jackpotDisplay,
		// 	reelAnimationParams: availableSpinParams[this.speedManager.GetDefaultReelSpeedType()],
		// 	FpsFactor: ChangeSpeedFactor[this.speedManager.GetDefaultCelebrationType()],
		// 	gameConfig : this.gameConfig,
		// 	symbolCollection : this.symbolCollection,
		// };

		// let bonusConfig: SpinAndHoldConfig = this.initData.BonusConfiguration.SpinAndHold;

		// let spinAndHoldBonus: SlotBonus = this.spinAndHoldBonusFactory_1Screen.CreateSpinAndHoldBonus_1Screen(this.gameName, bonusParams, bonusConfig);

		// // after bonus comes collect
		// //spinAndHoldBonus.SetBonusFinishedCallback(() => this.stateMachine.ChangeState(SlotGameState.BigWinTotal));
		// spinAndHoldBonus.SetBonusFinishedCallback(() => {
		// 	this.OnBonusFinished();
		// });

		// spinAndHoldBonus.SetBonusRunFinishedCallback((run: ISimpleBonusAction[]) => {
		// 	this.OnBonusRunFinish(run);
		// });

		// spinAndHoldBonus.SetBonusPanelRequiredCallback((required: boolean) => {
		// 	if (required)
		// 		this.panel.Show();
		// 	else
		// 		this.panel.Hide();
		// });

		// await spinAndHoldBonus.PrepareResources(loadingStage, resourceManager);

		// this.bonusList.set(Bonus.SpinAndHold, spinAndHoldBonus);
	}

	protected override OnBonusFinished(): void {		
		//this.screenProtocol?.Send(new SlotGameMessages.BonusFinished(this.currentBonus.Name()), this.screenProtocolScope);
		// Log.Debug(this.logGroup, "Current Bonus to hide " + this.currentBonus.Name());
		this.runingBonuses.pop();
		// Log.Debug(this.logGroup, "Removing bonus");
		this.onSimpleNextBonusAction = null;
		if (this.runingBonuses.length == 0) {			
			this.fillingPotFeature?.Create(this.gameViewAppPixi.GetAppView().stage);
			this.fillingPotFeature?.SetBet(this.selectedBet);
			this.bonusMultiplier?.SetBet(this.selectedBet);

			//this.spinnableReels.Create(this.fillingPotFeature?.containerSpinnableReelsSpine);
			this.fillingPotFeature?.RestartAnim();
			this.stateMachine.ChangeState(SlotGameState.BigWinTotal, { reason: "No more bonuses" });
			// Log.Debug(this.logGroup, "No more bonuses");
			this.lastBonus = null;
		}
		else {					
			let nextcurrentBonus = this.runingBonuses[this.runingBonuses.length - 1];
			// Log.Debug(this.logGroup, "New bonus " + this.currentBonus.Name());
		
			this.robotPlay.BonusStarted(nextcurrentBonus);

			if (this.lastBonus != nextcurrentBonus) {							
				//nextcurrentBonus.CreateTransitionPixi();
				//put for create reels or spine 
				//this.currentBonus.GameSelected(); 
				//have another bonus on BaseGame Won its not prepared and displayed 
				//need startConfig Bonus 				
				let currentindexData = this.lastSpinResult.Actions.findIndex((b) => b == this.lastSpinAction);
				this.onSimpleNextBonusAction = this.lastSpinResult.Actions.filter((b, index) => index > currentindexData && b.Bonus == nextcurrentBonus.Name());
				currentindexData = null;
				//this.screenProtocol?.Send(new SlotGameMessages.BonusRunResult(this.onSimpleNextBonusAction), this.screenProtocolScope);				
				this.timeoutWaitBonusStartConfig.Start();
				// setTimeout(() => {
				// 	this.stateMachine.ChangeState(SlotGameState.WaitBonusStartConfig)
				// }, 1500);
			} else {
				if (this.currentBonus != null) {					
					//setTimeout(() => {	
					this.currentBonus.Hide();
					this.currentBonus.GameExit();
					
					//this.currentBonus.DestroyTransition();
					//this.robotPlay.BonusEnded();
					this.currentBonus = null;

					//this.currentBonus.GameExit();
					//this.currentBonus.DestroyTransition();				
					//},500);
				}
				//you won 2 bonus on base game 
				//firt bonus was displayed and preapre
				//put for create reels or spine 				
				nextcurrentBonus.GameSelected(this.gameViewAppPixi.GetAppView().stage); 
				nextcurrentBonus.Show();
				nextcurrentBonus.NextBonusEnd();
				this.currentBonus = this.runingBonuses[this.runingBonuses.length - 1];
				if (Settings.fillingPotFeature == FillingPotFeature.Disable) {
					this.spinnableReels.Destroy("SlotGameType1.timeoutBonusShow");
				} else {
					this.fillingPotFeature?.Destroy();
				}

			}
		}
	}

	protected override async SpinAndHoldLoaded(loadingStage: LoadingStage, resourceManager: IReadOnlyResourceManager): Promise<void>
	{
		if (loadingStage != LoadingStage.Games)
		{
			return;
		}

		let spinAndHold = this.bonusList.get(Bonus.SpinAndHold);
		await spinAndHold.ResourcesLoaded(loadingStage, resourceManager);

		let bonusView = spinAndHold.View();
		//NEED QUIT AND CREATE ONE FOR EXTEDEND SPIN & HOLD
		//bonusView.style.width = this.multigameParams.viewSize.width + "px";
		//bonusView.style.height = this.multigameParams.viewSize.height + "px";
		this.basegameElement.appendChild(bonusView);

		// hide all bonuses by default
		spinAndHold.Hide();
	}

	protected override async BigSymbolFreegamesPrepare(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager): Promise<void> {

		let bonusParams: BigSymbolFreegamesBonusParams =
		{
			systemContext: this.systemContext,
			resid: this.resid,
			logGroup: this.logGroup,
			screenProtocol: this.screenProtocol,
			screenProtocolScope: this.screenProtocolScope,
            commonPath: this.commonpath,
            gamePath: this.basepath,
			screenSize: this.multigameParams.viewSize,
			playWindow: this.windowSymbolSize,
			// windowSymbolSize: this.windowSymbolSize,
			windowRectangle: this.windowRectangle,
			symbolSpriteAnims: this.symbolSpriteAnims,
			symbolSpriteAnimsByName: this.symbolSpriteAnimsByName,
			playlines: this.playlines,
			symbols: this.symbols,
			spinnableReelsParams: this.spinnableReelsParams,
			//reelSet: <number[][]>this.initData.bonusConfiguration["SpinAndHoldBonus"].ReelSet,
			//startPositions: [0, 0, 0, 0, 0],
			panel: this.panel,
			audio: this.audio,

			// TODO remove
			lines: this.selectedBet.Lines,

			// TODO remove?
			denom: this.selectedBet.Denom.InCents,

			// TODO remove?
			linesPlayed: this.selectedBet.Lines,

			clientState: this.clientState,
			translator: this.translator,
			robotPlay: this.robotPlay,
			slotGameMeta: this.initData.Meta,
			slotGameInitData: this.initData,
			slotGame: this,
			color: this.color,
			jackpotEnable : this.multigameParams.jackpotRequired,
			bonusAutoplay: this.multigameParams.backendSettings.GetBool("play.bonusautoplay", true),
			bonusList: this.bonusList,
			reelAnimationParams:availableSpinParams[this.speedManager.GetDefaultReelSpeedType()],
			FpsFactor: ChangeSpeedFactor[this.speedManager.GetDefaultCelebrationType()],
			winAnimationFactor: ChangeSpeedFactor[this.speedManager.GetDefaultCelebrationType()],
			gameConfig: this.gameConfig
		};

		let bonusConfig: BigSymbolFreegamesCommonConfiguration = this.initData.BonusConfiguration.BigSymbolFreegames;

		let bonus: SlotBonus = this.bigSymbolFreegameBonusFactory_1Screen.CreateBigSymbolFreegamesBonus_1Screen(this.gameName, bonusParams, bonusConfig);

		// after bonus comes collect
		//spinAndHoldBonus.SetBonusFinishedCallback(() => this.stateMachine.ChangeState(SlotGameState.BigWinTotal));
		bonus.SetBonusFinishedCallback(() => {
			this.OnBonusFinished();
		});

		bonus.SetBonusRunFinishedCallback((run: ISimpleBonusAction[]) => {
			this.OnBonusRunFinish(run);
		});

		bonus.SetBonusPanelRequiredCallback((required: boolean) => {
			if (required)
				this.panel.Show();
			else
				this.panel.Hide();
		});

		await bonus.PrepareResources(loadingStage, resourceManager);

		this.bonusList.set(Bonus.BigSymbolFreegames, bonus);
	}

	protected override async BigSymbolSpinAndHoldPrepare(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager): Promise<void> {

		let bonusParams: SpinAndHoldParams =
		{
			systemContext: this.systemContext,
			resid: this.resid,
			logGroup: this.logGroup,
			screenProtocol: this.screenProtocol,
			screenProtocolScope: this.screenProtocolScope,
			gamepath: this.basepath,
			commonpath: this.commonpath,
			gameBonusResourcesBasePath: this.basepath + "resources/HoldAndSpin/",
			commonBonusResourcesBasePath: this.commonpath + "resources/HoldAndSpin/",
			screenSize: this.multigameParams.viewSize,
			// windowRectangle: this.windowRectangle,
			symbolSpriteAnims: this.symbolSpriteAnims,
			symbolSpriteAnimsByName: this.symbolSpriteAnimsByName,
			playlines: this.playlines,
			symbols: this.symbols,
			spinnableReelsParams: this.spinnableReelsParams,
			//reelSet: <number[][]>this.initData.bonusConfiguration["SpinAndHoldBonus"].ReelSet,
			//startPositions: [0, 0, 0, 0, 0],
			panel: this.panel,
			audio: this.audio,
			// TODO remove
			lines: this.selectedBet.Lines,

			// TODO remove?
			denom: this.selectedBet.Denom.InCents,

			// TODO remove?
			linesPlayed: this.selectedBet.Lines,

			clientState: this.clientState,
			translator: this.translator,
			robotPlay: this.robotPlay,
			slotGameMeta: this.initData.Meta,
			slotGameInitData: this.initData,
			slotGame: this,
			color: this.color,
			jackpotEnable : this.multigameParams.jackpotRequired,
			bonusAutoplay: this.multigameParams.backendSettings.GetBool("play.bonusautoplay", true),
			pixiSpritesByName : this.pixiSpritesByName,
			reelAnimationParams:availableSpinParams[this.speedManager.GetDefaultReelSpeedType()],
			FpsFactor: ChangeSpeedFactor[this.speedManager.GetDefaultCelebrationType()],
			gameConfig : this.gameConfig,
			symbolCollection : this.symbolCollection,
		};

		let bonusConfig: SpinAndHoldCommonConfiguration = this.initData.BonusConfiguration.BigSymbolSpinAndHold;

		let spinAndHoldBonus: SlotBonus = this.bigSymbolSpinAndHoldBonusFactory_1Screen.CreateBigSymbolSpinAndHoldBonus1_Screen(this.gameName, bonusParams, bonusConfig) as any as SlotBonus;

		// after bonus comes collect
		//spinAndHoldBonus.SetBonusFinishedCallback(() => this.stateMachine.ChangeState(SlotGameState.BigWinTotal));
		spinAndHoldBonus.SetBonusFinishedCallback(() => {
			this.OnBonusFinished();
		});

		spinAndHoldBonus.SetBonusRunFinishedCallback((run: ISimpleBonusAction[]) => {
			this.OnBonusRunFinish(run);
		});

		spinAndHoldBonus.SetBonusPanelRequiredCallback((required: boolean) => {
			if (required)
				this.panel.Show();
			else
				this.panel.Hide();
		});

		await spinAndHoldBonus.PrepareResources(loadingStage, resourceManager);

		this.bonusList.set(Bonus.BigSymbolSpinAndHold, spinAndHoldBonus);
	}

	public override async GameSelected(): Promise<void> {
		if (this.stateMachine.IsState(SlotGameState.Idle)) {
			this.doubleUpView?.Create();

			this.gameViewAppPixi?.Create();
			// this.spinnableReels.Create();
			// this.bonusList.forEach((bonus) => bonus.GameSelected(this.gameViewAppPixi.GetAppView()));
			this.ShowGame()
			this.audio.PlayOrContinueLoop(this.resid.ScopedResourceName("background"));

			this.GameStateChanged?.(GameState.InGame);
			//Show denom when you enter game
			//only show if you have 2 denom for select
			//if not are some auto select.
			//always need change denom because not are the same for all games
			this.showDenomMenu = true;
			this.ShowAvailableDenoms();

			await this.OnResize(0, 0, GetOrientation());
		}
		// if (this.secondScreenHelp != null) {
		// 	this.secondScreenHelp.Start();
		// }
		//this.titleJPAnim?.Start();
	}

	public override ShowAvailableDenoms(): void 
    {
		if (this.stateMachine.State() == SlotGameState.Idle &&  this.showDenomMenu == true )
        {
			this.GameStateChanged?.(GameState.InGame);
            if (Settings.MenuType != MenuType.DummyMenu && this.availableDenoms.length > 1) {
                this.denomMenu.Show();
				
            }
            else 
            {              
                if (Settings.MenuType == MenuType.DummyMenu && this.availableDenoms.length > 1) {
                    this.denomMenu.Show();
                }
                else 
                {
					this.denomMenu.AutoDenom();
					//
					this.UpdateDenom?.(this.initData.EnabledBets, this.selectedBet.Denom.InCents);

					if (  this.GameStateChanged != null)  {
						this.timeoutGameState.Start();
						// setTimeout(() => {							
						// 	this.GameStateChanged(GameState.ReadyToPlay);
						// }, 1000);						
					}
                }
            }
			this.denomResponsiveContainer.style.display = "flex";
        }
	}

	public override SelectBet2(betIndex: number, force: boolean = false): boolean
	{
		return super.SelectBet2(betIndex, force);
	}



	public override GameExit() {
		// super.GameExit();
		if(this.secondScreenHelp != null)
		{
		this.secondScreenHelp.Reset();
		this.secondScreenHelp.Stop();
		}
		this.gameSelected = false;
		this.audio.StopAll();
		this.audio.Stop(this.resid.ScopedResourceName("background"));
		this.panel.Stop();
		this.GameStateChanged?.(GameState.SelectGame);
		

		// cleanup caches
		//this.symbolCache.Clear();		
		// this.gameViewAppPixi?.Destroy();
		// if (Settings.fillingPotFeature == FillingPotFeature.Disable) {
		// 	this.spinnableReels.Destroy();
		// } else {
		// 	this.fillingPotFeature?.Destroy();
		// }
		this.gameViewAppPixi?.Destroy();
		this.doubleUpView?.Destroy();
		//this.bonusList.forEach((bonus) => bonus.GameExit());
		this.lastSpinResult = null;
		//this.fillingPotFeature?.StopAnim();
		this.symbolCollection?.DestroyAllSymbols();
		//this.titleJPAnim?.Start();
	}

	protected override OnBonusBegin() {
		// super.OnBonusBegin()

		// if (this.runingBonuses.length != 0) {
		// 	if (this.secondScreenHelp != null) {
		// 		this.secondScreenHelp.Reset();
		// 		this.secondScreenHelp.Stop();
		// 	}
		// }
		//destroy bonus if you had 2 bonus at the same game 	
		// if(this.currentBonus != null) { 
		// 	this.currentBonus.GameExit();
		// }
	

			if (this.runingBonuses.length != 0) 
			{
				this.timeoutBonusShowTransition.Start();
				//this.currentBonus = this.runingBonuses[this.runingBonuses.length-1];
				//this.currentBonus.CreateTransitionPixi();
								
				this.TurboSpinStop();
				this.AutoplayDisable();				
				//this.bonusTriggerAnimation.Stop();				
				this.currentBonus = this.runingBonuses[this.runingBonuses.length-1];
				this.currentBonus.CreateTransitionPixi(this.gameViewAppPixi.GetAppView().stage);

				
				this.currentBonus.Prepare({
					actions: (this.onSimpleNextBonusAction ?? this.lastSpinResult.Actions) as ISimpleBonusAction[], 
					bet: this.bet,
				});

				this.panel.SetMessage(this.translator.t.message_bonustriggered);
			}
			else {
				this.stateMachine.ChangeState(SlotGameState.BigWinTotal);
				//this.stateMachine.ChangeState(SlotGameState.Collect);
			}
	}
	protected override OnBonusEnd() {
		super.OnBonusEnd();
		if (this.secondScreenHelp != null) {
			this.secondScreenHelp.Start();
		}
	}

    public override OnWaitGameStartBegin(): void {
        this.jackpotDisplay?.Pause();
        super.OnWaitGameStartBegin();
    }

    public override OnSpinBegin(): void {
        super.OnSpinBegin();
    }

    public override OnIdleBegin(): void {
        this.jackpotDisplay?.Resume();
        super.OnIdleBegin();
    }

	protected override BasegamePrepare(resourceManager: IWriteOnlyResourceManager) {
		resourceManager.Add(new ImageResource(this.basepath + "resources/background"+Settings.Screens+"S/"+"background.png", this.resid.ScopedResourceName([this.gameName, "background"+Settings.Screens+"S"])));

	}

	protected override BasegameLoaded(resourceManager: IReadOnlyResourceManager) {
		this.gameBackground = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName([this.gameName, "background"+Settings.Screens+"S"]));

		SetStyles(this.backgroundBaseGame, {
			backgroundImage: this.gameBackground.CssBackground(),
			backgroundSize: "100%",
		});
	}

	public override View(): HTMLElement {
		return this.gameView;
	}


	// protected BetChanged(betIndex: number, bet: SlotGameBet)
	// {
	// 	this.paytable1s?.SetBet(new SlotGameMessages.BetChange(bet.BetPerLineCredits, bet.BetPerLineCredits))
	// }
}